/**
 * 申请开票-开票金额分配工具
 */

/**
 * 按各订单「剩余金额」占比分配发票总额
 * - 以「分」为单位计算，采用最大余数法，保证返回值之和严格等于可分配总额（不超过各订单剩余合计）
 * - 且每个订单分配到的金额不超过其自身剩余金额
 * @param {Array<number|string>} amounts 各订单剩余可开票金额（invoice_money_surplus）
 * @param {number|string} total 待分配总额（发票金额）
 * @returns {string[]} 每个订单分配到的金额（保留 2 位小数的字符串）
 */
export function splitAmountByRatio(amounts, total) {
  const list = Array.isArray(amounts) ? amounts : []
  const count = list.length
  const result = new Array(count).fill('0.00')
  if (count === 0) {
    return result
  }

  const surplusCents = list.map(v => Math.max(0, Math.round((Number(v) || 0) * 100)))
  const surplusSum = surplusCents.reduce((a, b) => a + b, 0)
  if (surplusSum <= 0) {
    return result
  }

  // 可分配总额（分），不超过剩余合计（超出部分交由提交校验拦截）
  let totalCents = Math.round((Number(total) || 0) * 100)
  if (totalCents < 0) {
    totalCents = 0
  }
  if (totalCents > surplusSum) {
    totalCents = surplusSum
  }

  // 按占比计算理论值（分），先向下取整
  const quota = []
  let used = 0
  for (let i = 0; i < count; i++) {
    const ideal = totalCents * surplusCents[i] / surplusSum
    quota[i] = Math.floor(ideal)
    used += quota[i]
  }

  // 余数按理论值的小数部分从大到小分配，且不超过各自剩余
  let remain = totalCents - used
  const ratioOrder = list.map((_, i) => i)
      .filter(i => quota[i] < surplusCents[i])
      .sort((a, b) => {
        const fractionA = totalCents * surplusCents[a] / surplusSum - quota[a]
        const fractionB = totalCents * surplusCents[b] / surplusSum - quota[b]
        return fractionB - fractionA
      })
  for (let k = 0; k < ratioOrder.length && remain > 0; k++) {
    const i = ratioOrder[k]
    quota[i] += 1
    remain -= 1
  }

  for (let i = 0; i < count; i++) {
    result[i] = (quota[i] / 100).toFixed(2)
  }
  return result
}
